import React from "react";
import { Link } from "gatsby";
import "./sedeCard.scss";

type SedeCardProps = {
    sede: any;
};

type SedeItemsProps = {
    name: string;
    tipoDeOficina: string;
    image: any;
    mainPhone: string;
    mainAddress: string;
    slug: string;
};

function SedeCard({ sede }: SedeCardProps) {
    const { name, tipoDeOficina, image, mainPhone, mainAddress, slug }: SedeItemsProps = sede;


    return (
        <div className="m-sede__card">
            <div
                className="m-sede__card__img"
                style={{ backgroundImage: `url(${image[0].file.url})` }}
            ></div>
            <div className="m-sede__card__info">
                <h3 className="m-sede__card__info__name">
                    {name.replace("- Centro de Servicios", "")}
                </h3>
                <span className="m-sede__card__info__typeOffice">
                    {tipoDeOficina}
                </span>
                <div className="m-sede__card__info__description">
                    <div className="m-sede__card__info__description__icon">
                        <i className="icon-map-marker-alt"></i>
                    </div>
                    <p>{mainAddress}</p>
                </div>
                <div className="m-sede__card__info__description">
                    <div className="m-sede__card__info__description__icon">
                        <i className="icon-phone"></i>
                    </div>
                    <p>{mainPhone}</p>
                </div>
                <Link
                    target="_self"
                    rel="next"
                    className="m-sede__card__info__link"
                    to={`${slug.replace("https://www.comfama.com", "")}`}
                >
                    Ver más
                </Link>
            </div>
        </div>
    );
}

export default SedeCard;
